import React from "react";
import { useNavigate } from "react-router-dom";


import { PaperBG, MonoButton } from "../kits";

export default function HeroStatementSection({
  className = "",
  titleTop =  "Probleme lösen. ",
  titelTop2 = "Systeme bauen. ",
  titleBottom = "Wissen teilen.",
  description = `Keine Software um ihrer selbst willen.
Sondern Systeme, die funktionieren.
Und verstanden werden.`,
  description2 = `Software Archtiektur, Werkzeuge aus echter Praxis.`,
  buttonText = "Mein Weg - Mein Fokus",
  to = "/about#meinweg",
}) {
  const navigate = useNavigate();

  return (
    <section
      className={`relative overflow-hidden px-4 font-mono ${className}`}
    >
      {/* Background */}
      <PaperBG />

      <div className="relative z-10 max-w-4xl mx-auto flex flex-col items-center text-center pt-24 sm:pt-28 pb-16">

        {/* Headline */}
        <h1 className="mt-10 text-2xl sm:text-3xl md:text-4xl font-bold tracking-tight text-slate-900 leading-tight">
          {titleTop}
                 <span
            className="
              block mt-1
              text-brand
              drop-shadow-[0_0_12px_rgba(172,142,102,0.35)]
            "
          >
            {titelTop2}
          </span>
         
          <span
            className="
              block mt-1
              text-brand
              drop-shadow-[0_0_12px_rgba(172,142,102,0.35)]
            "
          >
            {titleBottom}
          </span>
       
        </h1>

        {/* Description */}
        <p className="mt-6 text-sm text-slate-700 max-w-2xl leading-relaxed">
          {description}
        </p>
        <p className="mt-6 text-sm text-slate-700 max-w-2xl leading-relaxed">
          {description2}
        </p>

        {/* CTA */}
        <div className="mt-8 flex flex-col sm:flex-row gap-3">
          <MonoButton
            onClick={() => navigate(to)}
            className="
              px-6 py-2 text-sm
              bg-[#151515]
              border-brand
              hover:bg-[transparent]
              sm:w-auto
              cursor-pointer
            "
            textColor="text-brand"
            underlineColors="ZenBrand"
          >
            {buttonText}
          </MonoButton>
        </div>
      </div>
    </section>
  );
}
